import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../../../services/admin';
import { CMSService } from '../../../services/cms-service';
import { Popup } from 'ng2-opd-popup';
import { Message } from 'model/modal-cms/message';
declare var mdtoast: any;
import Swal from 'sweetalert2'
import { compareByFieldSpecs } from '@fullcalendar/core';
declare var mdtoast: any;
var success_message = mdtoast("Statistique de consultation médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message2 = mdtoast("Statistique de répos médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message3 = mdtoast("Statistique de remboursement. Chargement de donnée... ", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message4 = mdtoast("Message, bien envoyer.", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var erreu_mes_vide = mdtoast("Opération nom effectuée, contenue message vide.", { duration: 5000, init: true, type: mdtoast.INFO });


var success_message4 = mdtoast('Opération effectuée avec succès.', { duration: 5000, init: true, type: mdtoast.SUCCESS });

@Component({
  selector: 'app-liste-question-agent',
  templateUrl: './liste-question-agent.component.html',
  styleUrls: ['./liste-question-agent.component.scss']
})
export class ListeQuestionAgentComponent implements OnInit {

  listeQuiestionByEtatCreer: any;
  listeQuiestionByEtatlire: any;
  id: any;
  im: number = 254778
  nom: string = "ANDRIANJATO ";
  prenom: string = "George Tsilavina";
  direction: string = "DIRECTION ADMINISTRATIVE ET FINANCIERE";
  sevice: string = "SERVICE CENTRE MEDICO-SOCIALE";
  @ViewChild('popup5') popup5: Popup;
  @ViewChild('popupProcedure') popupProcedure: Popup;


  message: Message = new Message(null)
  //236278
  agent_actuel: any;
  id_agent: any;
  id_agent_actuel: any;
  sum: any;
  nbr_quest_en_attante: any;
  mode_recherche:number=1;
  motCle:any;
  motCle2:any;
eta_mess_actuel:any;
  constructor(private adminService: AdminService, private router: Router, private cMSService: CMSService) {
    this.id_agent = this.adminService.getUserIMIscrit();
    let x = this.id_agent.split(" ");
    console.log(x);
    console.log(x.length);   
    if(x.length == 1){
     
      this.id_agent_actuel = this.adminService.getUserIMIscrit();
    }else{ 
      let y = x[0]
      let z = x[1]
      let w = x[2]
      let v = x[3]
      this.sum = y + z + w + v
      console.log(this.sum);      
      this.id_agent_actuel = this.sum    
    }


    


  }
  ngOnInit() {
    this.GetQuestionbyEtatCeer();
    this.GetQuestionbyEtatLire();
    console.log(this.id_agent_actuel)  
    this.getnombreQuestionEnAttante(); 
  }


  getnombreQuestionEnAttante() {
    this.adminService.getnombreQuestionEnAttanteByUser("c",this.id_agent_actuel)
        .subscribe(data => {
            this.nbr_quest_en_attante = data;
        }, err => {

        })
}


onChange(deviceValue) {
    console.log(deviceValue);  
    if(deviceValue=="d") {
      //recherche par Date
         this.mode_recherche=1;
    }else if(deviceValue=="m") {
      //recherche par mesage
      this.mode_recherche=2;
    }else if(deviceValue=="t") {
      //recherche tous messages
         this.mode_recherche=3;
      this.getToutMessage();
    }
   
    
   }

   onChangedefault(eventdefault){
    this.eta_mess_actuel = eventdefault

   }


   RechercheMessageParDate(){
    this.cMSService.getListeQuestionParMCComParDate(this.motCle,this.eta_mess_actuel)
    .subscribe(data => {
      if(this.eta_mess_actuel=="c"){
        this.listeQuiestionByEtatCreer = data
      }else{
        this.listeQuiestionByEtatlire = data
      }
    
      
    }, err => {
      console.log(err);
    })
  }




RechercheMessage(){
  this.cMSService.getListeQuestionParMC(this.motCle2,this.eta_mess_actuel, this.id_agent_actuel)
  .subscribe(data => {
    if(this.eta_mess_actuel=="c"){
      this.listeQuiestionByEtatCreer = data
      }else{
        this.listeQuiestionByEtatlire = data
      }

   
  }, err => {
    console.log(err);
  })
}


getParDate(){
  this.mode_recherche=1
}


getToutMessage(){
  this.GetQuestionbyEtatCeer();
  this.GetQuestionbyEtatLire();

}

getParMessage(){
  this.mode_recherche=2  
}


  // private adminService: AdminService,
  listeQuiestion() {
    this.cMSService.getListeQuestion()
      .subscribe(data => {
        console.log("alefa compte a " + data)
      }, err => {
        console.log(err);
      })
  }

  GetQuestionbyEtatCeer() {
    this.cMSService.getListeQuestiobyEtatCreerbyidagent("c", this.id_agent_actuel)
      .subscribe(data => {
        this.listeQuiestionByEtatCreer = data
      }, err => {
        console.log(JSON.parse(err._body).message);
      })
  }


  GetQuestionbyEtatLire() {
    this.cMSService.getListeQuestiobyEtatCreerbyidagent("l", this.id_agent_actuel)
      .subscribe(data => {
        this.listeQuiestionByEtatlire = data
      }, err => {
        console.log(JSON.parse(err._body).message);
      })
  }



  ouvrirDetailConsultation(id: number,id2:any) {
    this.router.navigate(['detail-question/'+id+"/"+id2]);
  }



  open(id_mess: number) {

    this.cMSService.getOneQuestio(id_mess)
      .subscribe(data => {
        this.message = data
      }, err => {
        console.log(JSON.parse(err._body).message);
      })

    this.popup5.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 1.5,
      header: "Question / reponse",
      widthProsentage: 40,
      animation: "fadeInRight",
      confirmBtnContent: "Modifier",
      cancleBtnContent: "Fermer",
    }

    this.popup5.show(this.popup5.options);
  }


  modifier() {
    //ok btn
    this.cMSService.updateMessage(this.message)
      .subscribe(data => {
        this.GetQuestionbyEtatCeer();
        this.popup5.hide();
        this.message = new Message(null)
        success_message4.show();
      }, err => {
        // console.log(JSON.parse(err._body).message);

      })
  }



  open_popup() {
    this.popupProcedure.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 2.5,
      header: "Question réponse",
      widthProsentage: 40,
      animation: "fadeInUp",
      confirmBtnContent: "Envoyer",
      cancleBtnContent: "Fermer",
    }

    this.popupProcedure.show(this.popupProcedure.options);
    this.message = new Message(null)

  }

  EnvoyerMessage() {

    if(this.message.contenue_mess == "" || this.message.contenue_mess == null  ){
      erreu_mes_vide.show();
    }else{
      Swal.fire({
        title: 'Envoi message',
        icon: 'info',
        text: this.message.contenue_mess,
        // icone: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, Envoyer!',
        cancelButtonText: 'Non'
      }).then((result) => {
        if (result.value) {
          //ok btn
          this.message.im_dest = this.id_agent_actuel
          this.message.date_mess = new Date();
          this.message.etat_mess ="c";
        //  this.message.date2 = new Date();
          // this.message.tel_dest = tel;
          // this.message.mail_dest = mail;
          // this.message.contenue_mess = contenu;
          this.cMSService.saveMessage(this.message)
            .subscribe(data => {
              success_message4.show();
              this.popupProcedure.hide();
              this.GetQuestionbyEtatCeer();
              this.getnombreQuestionEnAttante(); 
              this.message = new Message(null)
            }, err => {
              // console.log(JSON.parse(err._body).message);
  
            }) 
  
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          //cancel btn
        }
      });
    }







  }



}
